import { Select, SelectProps, forwardRef } from '@bitrise/bitkit';
import { getNames } from 'country-list';

export type CountrySelectorProps = SelectProps;

const COUNTRIES = getNames().sort();

const CountrySelector = forwardRef((props: CountrySelectorProps, ref) => {
  return (
    <Select label="Country" placeholder="Select country" {...props} ref={ref}>
      {COUNTRIES.map((name) => {
        return (
          <option key={name} value={name}>
            {name}
          </option>
        );
      })}
    </Select>
  );
});

export default CountrySelector;
